import React from 'react';
import { observer } from 'mobx-react';
import { Select } from '@mui/material';
const MultiAlignmentSelector = observer(function ({ model, }) {
    const { currentAlignment, alignmentNames } = model;
    return alignmentNames.length > 0 ? (React.createElement(Select, { native: true, value: currentAlignment, size: "small", onChange: event => {
            model.setCurrentAlignment(+event.target.value);
            model.setScrollX(0);
            model.setScrollY(0);
        } }, alignmentNames.map((option, index) => (React.createElement("option", { key: `${option}-${index}`, value: index }, option))))) : null;
});
export default MultiAlignmentSelector;
//# sourceMappingURL=MultiAlignmentSelector.js.map